import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";
import { handleImages } from "../Handle/defaults";
import { handlePull } from "./defaults";

interface UpdateObj {
  handleStyle: string;
  exactConfigImg?: string;
  handleColor?: string;
}

function useHandleSelector() {
  const addToQuote = useStore((state) => state.addToQuote);
  const handleStyle = useStore((state) => state.quote.handleStyle);
  const handleColor = useStore((state) => state.quote.handleColor);
  const handlePullLength = useStore((state) => state.quote.handlePullLength);
  const handlePullSide = useStore((state) => state.quote.handlePullSide);

  const exactConfigImg = useStore((state) => state.quote.exactConfigImg);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const handlePullSelected = Boolean(
    handlePull.find((itm) => itm.label === handleStyle),
  );

  const showHandlePulls = handleStyle === "Handle Pull" || handlePullSelected;

  const bluetoothHandleWifi = useStore(
    (state) => state.quote.bluetoothHandleWifi,
  );

  const bluetoothExtHandle = useStore(
    (state) => state.quote.bluetoothExtHandle,
  );

  const isEmtek = handleStyle === "Strata" || handleStyle === "Forge";

  const handleBluetoothExtHandleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value) {
      addToQuote({ bluetoothExtHandle: value });
      if (findRequired("Bluetooth Ext. Handle")) {
        removeRequired("Bluetooth Ext. Handle");
      }
    } else {
      addToQuote({ bluetoothExtHandle: "" });
    }
  };

  const handlePullLengthChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value) {
      addToQuote({ handlePullLength: value });
      if (findRequired("Handle Pull Length")) {
        removeRequired("Handle Pull Length");
      }
    } else {
      addToQuote({ handlePullLength: "" });
    }
  };

  const handlePullSideChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value) {
      addToQuote({ handlePullSide: value });
      if (findRequired("Handle Pull Side")) {
        removeRequired("Handle Pull Side");
      }
    } else {
      addToQuote({ handlePullSide: "" });
    }
  };

  const handleClick = (label: string) => {
    const checked = label === handleStyle;

    if (checked) {
      addToQuote({ handleStyle: "" }, "handleStyle");
    } else {
      let update: UpdateObj = { handleStyle: label, handleColor: "" };

      update["handlePullLength"] = "";

      const configIMG = !exactConfigImg
        ? ""
        : label === "Dallas Lever" && !exactConfigImg.includes("LEVER")
          ? `${exactConfigImg.split(".jpg")[0]}_LEVER.jpg`
          : label === "Handle Pull by Others" &&
              exactConfigImg.includes("LEVER")
            ? exactConfigImg.replace("_LEVER.jpg", ".jpg")
            : "";

      if (configIMG) {
        update["exactConfigImg"] = configIMG;
      }

      addToQuote(update, "handleColor");
    }
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    let update= { handleColor: value }
    if(showHandlePulls && !isEmtek){
      if(value === "Matte Black" && handlePullLength === "63\""){
        update["handlePullLength"] = ""
      }
    }
    addToQuote(update, "handleColor");

    if (value) {
      const errKey = showHandlePulls ? "Handle Pull Finish" : "Handle Finish"
      if (findRequired(errKey)) {
        removeRequired(errKey);
      }
    }
  };

  const handleWifiChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value) {
      addToQuote({ bluetoothHandleWifi: value });
      if (findRequired("Smart Lock Type")) {
        removeRequired("Smart Lock Type");
      }
    } else {
      addToQuote({ bluetoothHandleWifi: "" });
    }
  };

  const bluetoothHandleImg =
    handleStyle === "Smart Lock *" && bluetoothExtHandle
      ? handleImages.find((itm) => itm.label === bluetoothExtHandle)?.imgLabel
      : "";

  let handlePullLengthOptions = !handlePullSelected
    ? []
    : isEmtek
      ? ['24"', '36"', '48"', '72"']
      : ['31 1/2"', '47 1/4"', '63"'];

  let handlePullColors = ["Brushed Stainless Steel"];

  if (handleStyle !== "Monarch") {
    handlePullColors.push("Matte Black");
  }

  if (isEmtek) {
    handlePullColors.push("Satin Brass Stainless Steel");
  }else if(handleColor === "Matte Black"){
    handlePullLengthOptions = handlePullLengthOptions.filter(itm => itm !== "63\"")
  }

  return {
    handleChange,
    handleClick,
    handleColor,
    handleStyle,
    bluetoothHandleImg,
    bluetoothHandleWifi,
    handleWifiChange,
    handleBluetoothExtHandleChange,
    bluetoothExtHandle,
    showHandlePulls,
    handlePullLengthChange,
    handlePullLengthOptions,
    handlePullLength,
    handlePullColors,
    handlePullSideChange,
    handlePullSide,
    handlePullSelected,
  };
}

export default useHandleSelector;
